'use client';

import { useEffect } from 'react';

import { getLocaleFromPath } from '@/i18n/request';

export const useSyncLocaleCookie = () => {
  useEffect(() => {
    const sync = () => {
      const pathname = window.location.pathname;
      const locale = getLocaleFromPath(pathname);

      if (!locale) return;

      const match = document.cookie.match(/(?:^|;\s*)NEXT_LOCALE=([^;]*)/);
      const current = match?.[1];

      if (current?.toLowerCase() !== locale.toLowerCase()) {
        document.cookie = `NEXT_LOCALE=${locale.toLowerCase()}; path=/; SameSite=Strict`;
      }

      if (document.documentElement.lang !== locale.toLowerCase()) {
        document.documentElement.lang = locale.toLowerCase();
      }
    };
    sync();

    window.addEventListener('popstate', sync);

    return () => {
      window.removeEventListener('popstate', sync);
    };
  }, []);
};
